<div class="flex-container">
  <label
    class="tp-label"
    [class.invert]="isInvert"
    [class.tp-label--lg]="isInvert"
    [attr.for]="labelFor || null"
    *ngIf="label"
  >
    {{ label }}
    <span *ngIf="asterisk" class="tp-label__asterisk">*</span>
    <tp-icon
      *ngIf="labelIcon"
      class="tp-label__icon"
      [name]="labelIcon"
      [tpTooltip]="tooltipText || ''"
    ></tp-icon>
  </label>
  <div class="info-msg" *ngIf="infoMsg" [innerHTML]="infoMsg"></div>
</div>

<ng-content></ng-content>

<tp-error-content
  [show]="showErrors"
  [fieldErrors]="fieldErrors"
  [errorMappingKey]="errorMappingKey"
></tp-error-content>
